export const IsNull = (value) => {
  if (value === undefined || value === null) {
    return true;
  }

  if (value == "undefined" || value === "null") {
    return true;
  }
  if (value == "" || value == " ") {
    return true;
  }
  return false;
};

export const localStoreObjects = {
  userId: "userId",
  bgmiProfile: "bgmiProfile",
  profilePic: "profilePic",
  step: "step",
};

export const setLocalItem = (key, value) => {
  localStorage.setItem(key, value);
};
export const getLocalItem = (key) => {
  return localStorage.getItem(key);
};

export function convertDate(dateStr) {
  // Convert string to Date object
  const date = new Date(dateStr);

  // Format as "Month Day, Year"
  const options = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString("en-US", options);
}

export const getEstDateTime = (date = new Date()) => {
  const estTime = date.toLocaleString("en-US", {
    timeZone: "America/New_York",
  });
  return new Date(estTime);
};

export const formatEstDate = (date = new Date(), format = "yyyy-mm-dd") => {
  const estDate = date;
  // "dd-mm-yyyy"

  const map = {
    dd: String(estDate.getDate()).padStart(2, "0"),
    mm: String(estDate.getMonth() + 1).padStart(2, "0"),
    yyyy: String(estDate.getFullYear()),
    yy: String(estDate.getFullYear()).slice(-2),
    HH: String(estDate.getHours()).padStart(2, "0"),
    MM: String(estDate.getMinutes()).padStart(2, "0"),
    SS: String(estDate.getSeconds()).padStart(2, "0"),
  };

  return format.replace(/dd|mm|yyyy|yy|HH|MM|SS/g, (matched) => map[matched]);
};
